/**
 * @file
 * Help Center Contact Form script.
 */

(function hcContactFormScript($, Drupal, window, _) {
  'use strict';

  Drupal.behaviors.hcContactForm = {
    attach: function hcContactFormAttach(context, settings) {
      if (typeof settings !== 'undefined' &&
        typeof settings.pin_help_center_contact_form !== 'undefined') {
        if (typeof settings.pin_help_center_contact_form.navIndicator !== 'undefined') {
          var navClass = settings.pin_help_center_contact_form.navIndicator;
          $('.hc-contact-form__navigation li.active').removeClass('active');
          $('.hc-contact-form__navigation li.' + navClass).addClass('active');
        }
      }
      $(window).resize(function () {
        var availableWidth = $(window).width();
        if ($('.hc-contact-form__navigation-wrapper').length && availableWidth <= 580) {
          var navWrapper = $('.hc-contact-form__navigation-wrapper');
          var navList = $('.hc-contact-form__navigation');
          var activeItem = $('.active', navList);
          var activeOffset = activeItem.offset().left;
          var activeWidth = activeItem.width();
          var activeRight = activeOffset + activeWidth;
          var minLeft = Math.abs(availableWidth * 0.15);
          var minRight = Math.abs(availableWidth * -0.85);
          var skipGradient = false;
          if (navList.children().first().hasClass('active')) {
            skipGradient = true;
          }
          if (skipGradient === true) {
            navWrapper.addClass('no-left-gradient');
          }
          else {
            navWrapper.removeClass('no-left-gradient');
          }
          if (skipGradient === false && activeOffset < minLeft) {
            navList.offset({left: minLeft});
          }
          else if (activeRight > minRight) {
            navList.offset({left: -Math.abs(activeRight - minRight)});
          }
        }
        else {
          $('.hc-contact-form__navigation').css({left: 0});
        }
      }).resize();
      $('input[data-drupal-selector="edit-user-issue-subject"]', context).on('focus change', function () {
        window.pinSearch.renderSearch({el: 'search-reduced', variant: 'reduced', context: 'contact_form'});
      }).on('input', function () {
        window.pinSearch.doSearch($(this).val());
      });
      $('input[data-drupal-selector="edit-user-other-emails-add-submit"]').attr({
        value: Drupal.t('Add another email')
      });
      // Accordions.
      // Using setTimeout to work around WebForm's JS that opens accordion
      // options.
      setTimeout(function () {
        $('details', context).each(function () {
          if ($(this).attr('data-webform-key') !== 'account_access_options' &&
          $(this).is('[open]')) {
            $(this).attr('open', '').removeAttr('open');
          }
        });
      }, 0);
      // When the user clicks an issue category, close the currently open
      // category, open the one clicked on, and deselect any chosen option.
      $('details > summary').on('click', function () {
        var $parentSection = $(this).parent().parent();
        $(this).parent().removeAttr('closed');
        $('summary', $parentSection).not(this).each(function () {
          $(this).attr({
            'aria-expanded': 'false',
            'aria-pressed': 'false'
          }).parent().removeAttr('open').attr('closed', '');
        });
        $('input', $parentSection).not(this).each(function () {
          $(this).prop('checked', false);
        });
        // Make sure we re-set the submit to disabled when we do this.
        $parentSection.children()
          .filter('[data-drupal-selector="edit-actions-overview-1"]')
          .addClass('form-disabled')
          .find('input')
          .prop({
            disabled: true
          })
          .addClass('is-disabled');
      });
      // When the user makes a radio button selection on the first page,
      // ensure that the submit button becomes enabled.
      $('[data-drupal-selector="edit-overview-section-1-right"] input[type="radio"]').on('click', function () {
        $(this)
          .closest('[data-drupal-selector="edit-overview-section-1-right"]')
          .children()
          .filter('[data-drupal-selector="edit-actions-overview-1"]')
          .removeClass('form-disabled')
          .find('input')
          .prop({
            disabled: false
          })
          .removeClass('is-disabled');
      });
      // Sticky nav.
      var $nav = $('.hc-contact-form__navigation-wrapper', context);
      var $navHeight = $nav.outerHeight();
      var $distance = $($nav).offset();
      var $window = $(window);
      $window.scroll(function () {
        if ($nav.length > 0 && $window.scrollTop() >= ($distance.top - $navHeight)) {
          $($nav).addClass('sticky');
        }
        else {
          $($nav).removeClass('sticky');
        }
      });
      // Scroll to last completed section.
      var $activeSection = $('.section-active', context);
      if ($activeSection.length) {
        var $lastCompleted = $('.hc-contact-form__completed-sections').children().last();
        if ($lastCompleted.length) {
          var sectionScrollDistance = $lastCompleted.offset().top;
          var winHeight = $(window).height();
          var docHeight = $(document).height() - $lastCompleted.offset().top;
          if (!$lastCompleted.hasClass('scroll-complete') &&
              sectionScrollDistance > 240 &&
              docHeight > winHeight) {
            // 240px is the number needed to align the last completed with the form nav.
            $('html, body').animate({
              scrollTop: (sectionScrollDistance - 240)
            }, 1000);
            $lastCompleted.addClass('scroll-complete');
          }
        }
      }
      $('.pin-media-upload .image-upload-button ~ input[type="submit"]', context).attr('disabled', 'disabled');
      $('.pin-media-upload input[type="checkbox"]', context).on('change', function () {
        if (this.checked) {
          $('.pin-media-upload .image-upload-button ~ input[type="submit"]').removeAttr('disabled');
        }
      });
      var $userDeviceOptions = $('#user-device-options', context);
      if ($userDeviceOptions.length) {
        // Check if all options are blank and select on if so.
        var deviceExists = false;
        var device = device_detect().toString().toLowerCase();
        $('input', $userDeviceOptions).each(function () {
          if ($(this).prop('checked')) {
            deviceExists = true;
          }
        });
        if (deviceExists === false) {
          $('input', $userDeviceOptions).each(function () {
            if ($(this).val() === device) {
              $(this).prop('checked', true);
            }
          });
        }
      }
      var $userBrowserOptions = $('#user-browser-options', context);
      if ($userBrowserOptions.length) {
        // Check if all options are blank and select on if so.
        var browser = browser_detect().toString().toLowerCase();
        var broswerExists = false;
        $('input', $userBrowserOptions).each(function () {
          if ($(this).prop('checked')) {
            broswerExists = true;
          }
        });
        if (broswerExists === false) {
          $('input', $userBrowserOptions).each(function () {
            if ($(this).val() === browser) {
              $(this).prop('checked', true);
            }
          });
        }
      }
    }
  };

  function check_browser(browser) {
    var re = new RegExp(browser, 'i');
    return navigator.userAgent.match(re);
  }

  function device_detect() {

    var device = 'computer';
    var result = null;
    var devices = ['Android', 'IEMobile', 'iPhone', 'iPad', 'Kindle'];

    if (/Kindle|Android|iPhone|iPad|IEMobile/i.test(navigator.userAgent)) {
      $.each(devices, function (index, value) {
        device = check_browser(value);
        if (device !== null) {
          if (device === 'IEMobile') {
            result = 'windowsphone';
            return false;
          }
          result = device;
          return false;
        }
      });
    }

    return result || device;
  }

  function browser_detect() {

    var browsers = ['Edge', 'Firefox', 'OPR', 'Chrome', 'Safari', '.NET'];
    var result = null;

    $.each(browsers, function (index, value) {
      var browser_detected = check_browser(value);
      if (browser_detected !== null) {

        if (browser_detected === 'OPR') {
          result = 'other';
          return false;
        }

        if (browser_detected === '.NET' || browser_detected === 'Edge') {
          result = 'ie';
          return false;
        }
        result = browser_detected;
        return false;
      }
    });

    return result || 'other';
  }

}(jQuery, Drupal, window, _));
